module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    ref: "modal",
    staticClass: "modal",
    class: {
      'in': _vm.show
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    class: _vm.setSize
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), (!!_vm.header) ? _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.header))]) : _vm._e(), _vm._v(" "), _vm._t("header")], true), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body")], true), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer")], true)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-mask",
    on: {
      "click": _vm.close
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-36235fdd!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/comp/modal.vue
// module id = 306
// module chunks = 2